import * as SC from './styles'

type Props = {
  title: string
  url?: string
  onClick?: () => void
}

export const Item = (props: Props) => {
  const { title, url, onClick } = props

  return (
    <SC.Item
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
      data-qa={`table-action-${title.toString().toUpperCase()}`}
    >
      {title}
    </SC.Item>
  )
}
